export const FILE_CATEGORIES = {
  documentsWithBody: new Set([
    ".ai",
    ".eps",
    ".ps",
    ".doc",
    ".docm",
    ".docx",
    ".dot",
    ".dotx",
    ".dwg",
    ".azw4",
    ".djvu",
    ".epub",
    ".mobi",
    ".fdr",
    ".fdx",
    ".gdoc",
    ".gslides",
    ".key",
    ".kth",
    ".numbers",
    ".pages",
    ".odg",
    ".odp",
    ".odt",
    ".rtf",
    ".wpd",
    ".ods",
    ".binder",
    ".paper",
    ".papert",
    ".pdf",
    ".pps",
    ".ppsm",
    ".ppsx",
    ".ppt",
    ".pptm",
    ".pptx",
    ".txt",
    ".xls",
    ".xlsm",
    ".xlsx",
    ".hwp",
  ]),

  paginatedDocuments: new Set([
    ".pdf",
    ".doc",
    ".docm",
    ".docx",
    ".ppt",
    ".pptm",
    ".pptx",
    ".pps",
    ".ppsm",
    ".ppsx",
    ".xls",
    ".xlsm",
    ".xlsx",
    ".epub",
    ".mobi",
    ".djvu",
  ]),

  videoFiles: new Set([
    ".3gp",
    ".3gpp",
    ".3gpp2",
    ".asf",
    ".avi",
    ".dv",
    ".flv",
    ".m2t",
    ".m2ts",
    ".m4v",
    ".mkv",
    ".mov",
    ".mp4",
    ".mpeg",
    ".mpg",
    ".mts",
    ".mxf",
    ".oggtheora",
    ".ogv",
    ".rm",
    ".ts",
    ".vob",
    ".webm",
    ".wmv",
  ]),

  audioFiles: new Set([
    ".aac",
    ".aif",
    ".aiff",
    ".flac",
    ".m4a",
    ".m4r",
    ".mp3",
    ".oga",
    ".ogg",
    ".wav",
    ".wma",
  ]),

  imageFiles: new Set([
    ".jpg",
    ".jpeg",
    ".jpe",
    ".png",
    ".svg",
    ".psd",
    ".webp",
  ]),

  multiModalDocuments: new Set([
    ".pdf",
    ".gslide",
    ".pptx",
    ".pptm",
    ".odp",
    ".jpg",
    ".jpeg",
    ".jpe",
    ".png",
    ".svg",
    ".psd",
    ".webp",
  ]),
};

export const FILE_CATEGORIES_INVERTED_INDEX: Record<string, string[]> = {
  ".ai": ["documentsWithBody"],
  ".eps": ["documentsWithBody"],
  ".ps": ["documentsWithBody"],
  ".doc": ["documentsWithBody", "paginatedDocuments"],
  ".docm": ["documentsWithBody", "paginatedDocuments"],
  ".docx": ["documentsWithBody", "paginatedDocuments"],
  ".dot": ["documentsWithBody"],
  ".dotx": ["documentsWithBody"],
  ".dwg": ["documentsWithBody"],
  ".azw4": ["documentsWithBody"],
  ".djvu": ["documentsWithBody", "paginatedDocuments"],
  ".epub": ["documentsWithBody", "paginatedDocuments"],
  ".mobi": ["documentsWithBody", "paginatedDocuments"],
  ".fdr": ["documentsWithBody"],
  ".fdx": ["documentsWithBody"],
  ".gdoc": ["documentsWithBody"],
  ".gslides": ["documentsWithBody"],
  ".key": ["documentsWithBody"],
  ".kth": ["documentsWithBody"],
  ".numbers": ["documentsWithBody"],
  ".pages": ["documentsWithBody"],
  ".odg": ["documentsWithBody"],
  ".odp": ["documentsWithBody", "multiModalDocuments"],
  ".odt": ["documentsWithBody"],
  ".rtf": ["documentsWithBody"],
  ".wpd": ["documentsWithBody"],
  ".ods": ["documentsWithBody"],
  ".binder": ["documentsWithBody"],
  ".paper": ["documentsWithBody"],
  ".papert": ["documentsWithBody"],
  ".pdf": ["documentsWithBody", "paginatedDocuments", "multiModalDocuments"],
  ".pps": ["documentsWithBody", "paginatedDocuments"],
  ".ppsm": ["documentsWithBody", "paginatedDocuments"],
  ".ppsx": ["documentsWithBody", "paginatedDocuments"],
  ".ppt": ["documentsWithBody", "paginatedDocuments"],
  ".pptm": ["documentsWithBody", "paginatedDocuments", "multiModalDocuments"],
  ".pptx": ["documentsWithBody", "paginatedDocuments", "multiModalDocuments"],
  ".txt": ["documentsWithBody"],
  ".xls": ["documentsWithBody", "paginatedDocuments"],
  ".xlsm": ["documentsWithBody", "paginatedDocuments"],
  ".xlsx": ["documentsWithBody", "paginatedDocuments"],
  ".hwp": ["documentsWithBody"],

  // Video
  ".3gp": ["videoFiles"],
  ".3gpp": ["videoFiles"],
  ".3gpp2": ["videoFiles"],
  ".asf": ["videoFiles"],
  ".avi": ["videoFiles"],
  ".dv": ["videoFiles"],
  ".flv": ["videoFiles"],
  ".m2t": ["videoFiles"],
  ".m2ts": ["videoFiles"],
  ".m4v": ["videoFiles"],
  ".mkv": ["videoFiles"],
  ".mov": ["videoFiles"],
  ".mp4": ["videoFiles"],
  ".mpeg": ["videoFiles"],
  ".mpg": ["videoFiles"],
  ".mts": ["videoFiles"],
  ".mxf": ["videoFiles"],
  ".oggtheora": ["videoFiles"],
  ".ogv": ["videoFiles"],
  ".rm": ["videoFiles"],
  ".ts": ["videoFiles"],
  ".vob": ["videoFiles"],
  ".webm": ["videoFiles"],
  ".wmv": ["videoFiles"],

  // Audio
  ".aac": ["audioFiles"],
  ".aif": ["audioFiles"],
  ".aiff": ["audioFiles"],
  ".flac": ["audioFiles"],
  ".m4a": ["audioFiles"],
  ".m4r": ["audioFiles"],
  ".mp3": ["audioFiles"],
  ".oga": ["audioFiles"],
  ".ogg": ["audioFiles"],
  ".wav": ["audioFiles"],
  ".wma": ["audioFiles"],

  // Images
  ".jpg": ["imageFiles", "multiModalDocuments"],
  ".jpeg": ["imageFiles", "multiModalDocuments"],
  ".jpe": ["imageFiles", "multiModalDocuments"],
  ".png": ["imageFiles", "multiModalDocuments"],
  ".svg": ["imageFiles", "multiModalDocuments"],
  ".psd": ["imageFiles", "multiModalDocuments"],
  ".webp": ["imageFiles", "multiModalDocuments"],

  // Multi-modal documents (additional)
  ".gslide": ["multiModalDocuments"],
};

/**
 * Constant for PAP action_element
 */
export const DROPBOX_AI_BLADE = "dropbox_ai_blade";

/**
 * Mapping of ConversationSource to PAP action_surface values
 */
export const ACTION_SURFACE_MAPPING = {
  "fss-unscoped": "browse_screen",
  "fss-file": "browse_screen",
  "fss-file-preview": "previews",
  "fss-folder": "browse_screen",
  "fss-serp-query": "search_result_page",
  "fss-serp-typeahead": "search_result_page",
  "fss-stack": "stacks_page",
};
